import {Component, Inject, signal, WritableSignal} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogActions, MatDialogClose, MatDialogRef} from "@angular/material/dialog";
import {JointjsPlusComponent} from "../../jointjs-plus/jointjs-plus.component";
import {MatButton} from "@angular/material/button";
import {MatIconModule} from "@angular/material/icon";
import {ReactiveFormsModule} from "@angular/forms";
import {MatSlideToggle} from "@angular/material/slide-toggle";

@Component({
  selector: 'app-jointjs-modal',
  standalone: true,
  imports: [
    JointjsPlusComponent,
    MatDialogActions,
    MatButton,
    MatDialogClose,
    MatIconModule,
    ReactiveFormsModule,
    MatSlideToggle
  ],
  templateUrl: './jointjs-readonly-modal.component.html',
  styleUrl: './jointjs-readonly-modal.component.scss'
})
export class JointjsReadonlyModalComponent {
  logigramme: any;
  procedureTitre: string;

  isLogigrammeBeingSaved: WritableSignal<boolean>;

  constructor(public dialogRef: MatDialogRef<JointjsReadonlyModalComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    this.isLogigrammeBeingSaved = signal(false);
    this.logigramme = data.logigramme;
    this.procedureTitre = data.procedureTitre;
    if (this.data.logigramme && Object.keys(this.data.logigramme).length > 0) {
      this.logigramme = this.data.logigramme;
    } else {
      this.logigramme = {}
    }
  }

  closeDialog(closeDialog: boolean) {
    if (closeDialog) {
      this.dialogRef.close(this.logigramme);
    }
  }

  sendLogigramme() {
    this.dialogRef.close(this.logigramme);
  }
}
